import { render, staticRenderFns } from "./NewInspectionForm.vue?vue&type=template&id=65038119&"
import script from "./NewInspectionForm.vue?vue&type=script&lang=js&"
export * from "./NewInspectionForm.vue?vue&type=script&lang=js&"
import style0 from "./NewInspectionForm.vue?vue&type=style&index=0&id=65038119&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports